import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GetAppIcon from "@mui/icons-material/GetApp";
import AddToHomeScreenIcon from "@mui/icons-material/AddToHomeScreen";
import IosShareIcon from "@mui/icons-material/IosShare";

const ManualInstallModal = ({ open, onClose }) => {
  // Comprehensive device & browser detection
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // iOS detection (iPhone, iPad, iPod)
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  // Android detection
  const isAndroid = /android/i.test(userAgent);

  // macOS detection
  const isMacOS = /Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent) && !isIOS;

  // Safari detection (iOS or macOS)
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

  // Chrome detection
  const isChrome =
    /Chrome/.test(userAgent) &&
    /Google Inc/.test(navigator.vendor) &&
    !/Edg/.test(userAgent);

  // Edge detection
  const isEdge = /Edg/.test(userAgent);

  // Firefox detection
  const isFirefox = /Firefox/.test(userAgent);

  // Opera detection
  const isOpera = /OPR/.test(userAgent);

  const getBrowserName = () => {
    if (isSafari) return "Safari";
    if (isOpera) return "Opera";
    if (isEdge) return "Edge";
    if (isFirefox) return "Firefox";
    if (isChrome) return "Chrome";
    return "your browser";
  };

  // iOS Safari instructions
  const renderIOSInstructions = () => (
    <List sx={{ bgcolor: "rgba(0,0,0,0.03)", borderRadius: "12px", p: 2 }}>
      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          1
        </Box>
        <ListItemText
          primary={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography variant="body2">Tap the</Typography>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  bgcolor: "rgba(0, 113, 227, 0.1)",
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                }}
              >
                <IosShareIcon sx={{ fontSize: 18, color: "#0071e3" }} />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#0071e3" }}
                >
                  Share
                </Typography>
              </Box>
              <Typography variant="body2">
                button at the bottom of Safari
              </Typography>
            </Box>
          }
        />
      </ListItem>

      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          2
        </Box>
        <ListItemText
          primary={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography variant="body2">Scroll down and tap</Typography>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  bgcolor: "rgba(0, 113, 227, 0.1)",
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                }}
              >
                <AddToHomeScreenIcon sx={{ fontSize: 16, color: "#0071e3" }} />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#0071e3" }}
                >
                  Add to Home Screen
                </Typography>
              </Box>
            </Box>
          }
        />
      </ListItem>

      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          3
        </Box>
        <ListItemText
          primary={
            <Typography variant="body2">
              Tap <strong>Add</strong> in the top right corner
            </Typography>
          }
        />
      </ListItem>
    </List>
  );

  // Android Chrome instructions
  const renderAndroidInstructions = () => (
    <List sx={{ bgcolor: "rgba(0,0,0,0.03)", borderRadius: "12px", p: 2 }}>
      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          1
        </Box>
        <ListItemText
          primary={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography variant="body2">Tap the</Typography>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  bgcolor: "rgba(0, 113, 227, 0.1)",
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                }}
              >
                <MoreVertIcon sx={{ fontSize: 18, color: "#0071e3" }} />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#0071e3" }}
                >
                  Menu
                </Typography>
              </Box>
              <Typography variant="body2">
                button (3 dots) in the top right
              </Typography>
            </Box>
          }
        />
      </ListItem>

      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          2
        </Box>
        <ListItemText
          primary={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography variant="body2">Tap</Typography>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  bgcolor: "rgba(0, 113, 227, 0.1)",
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                }}
              >
                <AddToHomeScreenIcon sx={{ fontSize: 16, color: "#0071e3" }} />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#0071e3" }}
                >
                  Add to Home screen
                </Typography>
              </Box>
              <Typography variant="body2">or</Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: "#0071e3" }}
              >
                Install app
              </Typography>
            </Box>
          }
        />
      </ListItem>

      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          3
        </Box>
        <ListItemText
          primary={
            <Typography variant="body2">
              Tap <strong>Install</strong> or <strong>Add</strong> to confirm
            </Typography>
          }
        />
      </ListItem>
    </List>
  );

  // Desktop Chrome/Edge instructions
  const renderDesktopInstructions = () => (
    <List sx={{ bgcolor: "rgba(0,0,0,0.03)", borderRadius: "12px", p: 2 }}>
      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          1
        </Box>
        <ListItemText
          primary={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography variant="body2">Look for the</Typography>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  bgcolor: "rgba(0, 113, 227, 0.1)",
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                }}
              >
                <GetAppIcon sx={{ fontSize: 16, color: "#0071e3" }} />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#0071e3" }}
                >
                  Install
                </Typography>
              </Box>
              <Typography variant="body2">icon in the address bar</Typography>
            </Box>
          }
        />
      </ListItem>

      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          2
        </Box>
        <ListItemText
          primary={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography variant="body2">Or click the</Typography>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  bgcolor: "rgba(0, 113, 227, 0.1)",
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                }}
              >
                <MoreVertIcon sx={{ fontSize: 18, color: "#0071e3" }} />
              </Box>
              <Typography variant="body2">menu then</Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: "#0071e3" }}
              >
                Install The Linkup
              </Typography>
            </Box>
          }
        />
      </ListItem>

      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          3
        </Box>
        <ListItemText
          primary={
            <Typography variant="body2">
              Click <strong>Install</strong> in the popup to confirm
            </Typography>
          }
        />
      </ListItem>
    </List>
  );

  // macOS Safari instructions
  const renderMacSafariInstructions = () => (
    <List sx={{ bgcolor: "rgba(0,0,0,0.03)", borderRadius: "12px", p: 2 }}>
      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          1
        </Box>
        <ListItemText
          primary={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography variant="body2">Click</Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: "#0071e3" }}
              >
                File
              </Typography>
              <Typography variant="body2">in the menu bar</Typography>
            </Box>
          }
        />
      </ListItem>

      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          2
        </Box>
        <ListItemText
          primary={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography variant="body2">Select</Typography>
              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.5,
                  bgcolor: "rgba(0, 113, 227, 0.1)",
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                }}
              >
                <AddToHomeScreenIcon sx={{ fontSize: 16, color: "#0071e3" }} />
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#0071e3" }}
                >
                  Add to Dock
                </Typography>
              </Box>
            </Box>
          }
        />
      </ListItem>

      <ListItem sx={{ px: 0, py: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "#0071e3",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 700,
            mr: 2,
            flexShrink: 0,
          }}
        >
          3
        </Box>
        <ListItemText
          primary={
            <Typography variant="body2">
              Click <strong>Add</strong> to install the app
            </Typography>
          }
        />
      </ListItem>
    </List>
  );

  // Choose correct instructions based on device/browser
  const renderInstructions = () => {
    if (isIOS) {
      return renderIOSInstructions();
    }
    if (isAndroid) {
      return renderAndroidInstructions();
    }
    if (isMacOS && isSafari) {
      return renderMacSafariInstructions();
    }
    // Default: Desktop Chrome/Edge/other
    return renderDesktopInstructions();
  };

  const getSubtitle = () => {
    if (isIOS) {
      return "Install The Linkup on your iPhone or iPad using Safari:";
    }
    if (isAndroid) {
      return `Install The Linkup on your Android device using ${getBrowserName()}:`;
    }
    if (isMacOS && isSafari) {
      return "Install The Linkup on your Mac using Safari:";
    }
    return `Install The Linkup using ${getBrowserName()}:`;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: "#ffffff",
          color: "#1d1d1f",
          borderRadius: "16px",
          border: "1px solid rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <GetAppIcon sx={{ color: "#0071e3" }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Install The Linkup
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ mb: 3, color: "rgba(0,0,0,0.6)" }}>
          {getSubtitle()}
        </Typography>

        {renderInstructions()}

        <Typography
          variant="caption"
          sx={{ mt: 2, display: "block", color: "rgba(0,0,0,0.55)" }}
        >
          The app will appear on your{" "}
          {isIOS || isAndroid ? "home screen" : "dock/taskbar"} like a native
          app!
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          fullWidth
          sx={{
            bgcolor: "#0071e3",
            color: "#fff",
            fontWeight: 700,
            borderRadius: "12px",
            py: 1.5,
            "&:hover": {
              bgcolor: "#005bb5",
            },
          }}
        >
          Got it!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManualInstallModal;
